import { render, staticRenderFns } from "./size-range.vue?vue&type=template&id=a67183be&scoped=true"
import script from "./size-range.vue?vue&type=script&setup=true&lang=js"
export * from "./size-range.vue?vue&type=script&setup=true&lang=js"
import style0 from "./size-range.vue?vue&type=style&index=0&id=a67183be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67183be",
  null
  
)

export default component.exports